import { useState } from 'react';
import { initI18nWithoutICU } from '@wix/wix-i18n-config';
import type { Essentials } from '../contexts/essentials-context';
import { useTranslationsLoader } from './translations';

type Props = {
  languageCode?: string;
  experiments?: Essentials['experiments'];
};

export const useInitEssentials = (
  props: Props,
): { essentials: Essentials; ready: boolean } => {
  const languageCode = props?.languageCode ?? 'en';
  const experiments = props?.experiments;
  const [i18n] = useState(
    initI18nWithoutICU({
      locale: languageCode,
      messages: {},
    }),
  );
  const { t, ready } = useTranslationsLoader(i18n);
  return { essentials: { t, languageCode, experiments }, ready };
};
